import {ChangeDetectionStrategy, Component, inject, signal} from '@angular/core';
import {CommonModule} from "@angular/common";
import {Button} from "primeng/button";
import {FormsModule} from "@angular/forms";
import {NotificationService} from "../../services/notification.service";
import {MessageService} from "primeng/api";
import {environment} from "../../environments/environment";
import {Router} from "@angular/router";
import {finalize, of, tap, Observable} from "rxjs";
import {SubmitButtonComponent} from "../../components/submit-button/submit-button.component";

@Component({
  selector: 'app-manual-notification-check-page',
  standalone: true,
  imports: [CommonModule, FormsModule, SubmitButtonComponent, Button],
  templateUrl: './manual-notification-check-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ManualNotificationCheckPageComponent {
  protected readonly enabled = environment.allowManualNotificationCheck === true;
  protected readonly allowCustomTime = environment.allowManualNotificationCheckCustomTime === true;
  protected loading = signal(false);
  protected currentTime = '';
  private readonly notificationService = inject(NotificationService);
  private readonly messageService = inject(MessageService);
  private readonly router = inject(Router);

  protected trigger: () => Observable<unknown> = () => {
    if (!this.enabled) {
      return of(undefined);
    }

    const currentTimePayload = this.allowCustomTime ? (this.currentTime.trim() || undefined) : undefined;
    this.loading.set(true);
    return this.notificationService.manualCheckForNotifications(currentTimePayload).pipe(
      tap({
        next: () => this.messageService.add({
          severity: 'success',
          summary: 'Triggered',
          detail: 'Check-for-notifications lambda invoked.'
        }),
        error: () => this.messageService.add({
          severity: 'error',
          summary: 'Failed',
          detail: 'Could not trigger notification check.'
        })
      }),
      finalize(() => this.loading.set(false))
    );
  }

  protected goBack() {
    this.router.navigate(['/users']);
  }
}
